import * as React from 'react';
import classnames from 'classnames';
import { Select } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { PLACEHOLDER } from '../../../../../../../../constants.js';
import { getEyeLabel, getAttributeLabel, getFilterOptions, sortPowerOptions } from '../../../../../utils.js';
import { LabelWithTooltip } from '../LabelWithTooltip/LabelWithTooltip.js';
import { ReadOnlyElement } from '../ReadOnlyElement/ReadOnlyElement.js';
import { SelectWrapper } from '../SelectWrapper/SelectWrapper.js';

/**
 * This method checks if there is only one option available.
 * If this is the case, return only this value.
 * This will make sure the select boxes are prefilled with the only available option.
 */ const getInitialState = (options)=>{
    if (!options) {
        return undefined;
    }
    if (options instanceof Set && options.size === 1) {
        const value = options.values().next().value;
        return {
            value
        };
    }
    if (Array.isArray(options) && options[0]) {
        const value = options[0].value;
        return {
            value
        };
    }
    return {
        value: ''
    };
};
const SelectElement = (props)=>{
    var ref;
    const { attribute , handleAttributeChange , activeFilters , className , attributes , id , hasError , isActive , foundProduct ,  } = props;
    const intl = useIntl();
    const attibuteValues = (ref = attributes[attribute]) === null || ref === void 0 ? void 0 : ref.values;
    const filter = activeFilters[attribute];
    const initialState = filter ? {
        value: filter
    } : getInitialState(attibuteValues);
    const onlyOneOptionAvailble = (attibuteValues === null || attibuteValues === void 0 ? void 0 : attibuteValues.size) === 1 && initialState;
    const hasSelectedValue = (initialState === null || initialState === void 0 ? void 0 : initialState.value) !== '';
    const selectElementClass = classnames('select-element', {
        'select-element--error': hasError && !foundProduct && isActive
    }, className);
    const eyeLabel = getEyeLabel(intl, id);
    const attributeLabel = getAttributeLabel(intl, attribute);
    if (onlyOneOptionAvailble && initialState) {
        return /*#__PURE__*/ React.createElement(ReadOnlyElement, {
            attribute: attribute,
            value: initialState.value,
            id: id
        });
    }
    return /*#__PURE__*/ React.createElement(SelectWrapper, {
        key: attribute
    }, /*#__PURE__*/ React.createElement(LabelWithTooltip, {
        type: attribute,
        id: id
    }), /*#__PURE__*/ React.createElement(Select, {
        id: `${attribute}-${id}`,
        className: selectElementClass,
        name: intl.getLabel(`products.contactLenses.prescription.${attribute}`),
        options: getFilterOptions(attibuteValues),
        sortOptionsBy: attribute === 'power' ? sortPowerOptions : undefined,
        initialState: initialState,
        placeholder: PLACEHOLDER,
        onChange: (value)=>handleAttributeChange(attribute, value)
        ,
        disabled: !isActive,
        "aria-label": `${attributeLabel} ${eyeLabel}`,
        "aria-invalid": hasError && !hasSelectedValue,
        "data-t": `prescription-${attribute}`
    }));
};

export { SelectElement, getInitialState };
//# sourceMappingURL=SelectElement.js.map
